export const pressReleaseGettingStartedArticle = {
  title: 'Press Release Generator: Getting Started',
  slug: 'press-release-getting-started',
  content: `Press Release Generator: Getting Started

Create AP-style press releases with quotes and boilerplates.

1) Open the generator
- Go to /marketing/press-release-generator.

2) Fill core details
- Company name, city/state, topic, and industry are used for the headline and dateline.
- Add key details and a boilerplate.

3) Add quotes and contacts
- Add at least one quote with name, title, and quote text.
- Enter press contact name and email.

4) Generate and copy
- Submit to generate the release.
- Copy the output when it’s ready.
`,
};
